<template>
  <div class="card" id="visualEffect">
    <nav class="fixed-bar navbar navbar-expand-lg navbar-light" color="white">
      <h3 class="navbar-brand">Visual Effect</h3>
      <add-effect
        @save="saveSetDesign"
        @open="openDialog"
        @close="closeDialog"
        v-bind:dialog="dialog"
        v-bind:info="editedItem"
        v-bind:edited-i-d="editedID"
        v-bind:showSaveButton="showSaveButton">
      </add-effect>
    </nav>
    <hr/>
    <div class="container fluid grid-list-lg">
      <asset-table
        v-bind:updated="updated"
        v-bind:asset_type="asset_type"
        @edit="editItem"
        v-bind:headers="headers">
      </asset-table>
    </div>
  </div>
</template>

<script>
import { db, assetMediaStorageRef } from '../../firebaseDB'
import addEffect from './add-new/addEffect'
import AssetTable from './assetTable'
import _ from 'lodash'

export default {
  name: 'basic_character_action',
  components: { AssetTable, addEffect },
  data: () => ({
    asset_type: 'effect',
    headers: [
      {th: 'Name', name: 'name'},
      {th: 'Date Uploaded', name: 'date_uploaded'},
      // {th: 'Date Modified', name: 'date_modified'},
      {th: 'Uploaded By', name: 'creator'},
      // {th: 'Description', name: 'description'},
      // {th: 'Service', name: 'service'},
      {th: 'Media',
        name: 'media',
        render (row, cell, index) {
          if (row.hasOwnProperty('image')) {
            return `<a href="${row.image.imageURL}" target="_blank">
                  <img src="${row.image.imageURL}" style="width: 50px; height: 50px">
                </a>`
          } else if (row.hasOwnProperty('audio')) {
            return `<button type="button" class="btn btn-default"></button>`
          } else {
            return ''
          }
        }
      }
    ],
    fileType: {
      image: 'image',
      fbx: 'fbx',
      asset_bundle: 'asset_bundle'
    },
    osType: {
      iOS: 'iOS',
      Android: 'Android',
      WebGL: 'WebGL'
    },
    dialog: '',
    updated: false,
    showSaveButton: true,
    editedItem: {
      image: null,
      name: '',
      service: '',
      description: '',
      effectType: '',
      allow_sound: true,
      fbx: {
        fileName: '',
        file: '',
        fileURL: ''
      },
      asset_bundle: {
        iOS: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        Android: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        WebGL: {
          fileName: '',
          file: '',
          fileURL: ''
        }
      },
      rotationOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      positionOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      scaleOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      numberOfLoops: 0,
      duration: 0,
      identifiableSurface: '',
      movementElement: ''
    },
    defaultItem: {
      image: null,
      name: '',
      service: '',
      description: '',
      effectType: '',
      allow_sound: true,
      fbx: {
        fileName: '',
        file: '',
        fileURL: ''
      },
      asset_bundle: {
        iOS: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        Android: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        WebGL: {
          fileName: '',
          file: '',
          fileURL: ''
        }
      },
      rotationOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      positionOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      scaleOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      numberOfLoops: 0,
      duration: 0,
      identifiableSurface: '',
      movementElement: ''
    },
    editedID: -1,
    editedIndex: -1,
    tableData: []
  }),
  methods: {
    saveSetDesign (updatedData) {
      setTimeout(() => {
        let updates = {}
        let requireDefaultUpdate = true

        this.updateMetaData(updatedData, updates)
        console.log(updatedData.id)

        updates[`asset_data/${this.asset_type}/${updatedData.id}/name`] = updatedData.name || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/prefabName`] = updatedData.prefabName || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/service`] = updatedData.service || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/description`] = updatedData.description || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/effectType`] = updatedData.effectType
        updates[`asset_data/${this.asset_type}/${updatedData.id}/allow_sound`] = updatedData.allow_sound || true
        updates[`asset_data/${this.asset_type}/${updatedData.id}/rotationOfOrigin`] = {
          X: updatedData.rotationOfOrigin.X || '0',
          Y: updatedData.rotationOfOrigin.Y || '0',
          Z: updatedData.rotationOfOrigin.Z || '0'
        }
        updates[`asset_data/${this.asset_type}/${updatedData.id}/positionOfOrigin`] = {
          X: updatedData.positionOfOrigin.X || '0',
          Y: updatedData.positionOfOrigin.Y || '0',
          Z: updatedData.positionOfOrigin.Z || '0'
        }
        updates[`asset_data/${this.asset_type}/${updatedData.id}/scaleOfOrigin`] = {
          X: updatedData.scaleOfOrigin.X || '0',
          Y: updatedData.scaleOfOrigin.Y || '0',
          Z: updatedData.scaleOfOrigin.Z || '0'
        }
        updates[`asset_data/${this.asset_type}/${updatedData.id}/loop`] = updatedData.loop || 0
        updates[`asset_data/${this.asset_type}/${updatedData.id}/duration`] = updatedData.duration || 0
        updates[`asset_data/${this.asset_type}/${updatedData.id}/identifiableSurface`] = updatedData.identifiableSurface || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/movementElement`] = updatedData.movementElement || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/componentType`] = updatedData.componentType || 'Character'

        if (this.shouldUpload(this.fileType.image, updatedData)) {
          this.uploadImage(updatedData, updates)
          requireDefaultUpdate = false
        }
        if (this.shouldUpload(this.fileType.fbx, updatedData)) {
          this.uploadFBX(updatedData, updates)
          requireDefaultUpdate = false
        }
        if (this.shouldUpload(this.fileType.asset_bundle, updatedData)) {
          this.uploadAssetBundle(updatedData, updates, this.osType.iOS)
          this.uploadAssetBundle(updatedData, updates, this.osType.Android)
          this.uploadAssetBundle(updatedData, updates, this.osType.WebGL)
          requireDefaultUpdate = false
        }
        if (requireDefaultUpdate) {
          db.ref('assets').update(updates).then(snapshot => {
            this.closeDialog()
            this.updated = true
          })
        }
      }, 2000)
      this.updated = false
    },
    getDatetime () {
      const currentdate = new Date()
      return currentdate.getDate() + '/' +
        (currentdate.getMonth() + 1) + '/' +
        currentdate.getFullYear() + ' @ ' +
        currentdate.getHours() + ':' +
        currentdate.getMinutes() + ':' +
        currentdate.getSeconds()
    },
    updateMetaData (updatedData, updates) {
      const datetime = this.getDatetime()
      if (!updatedData.id) {
        updatedData.id = db.ref(`asset_data/${this.asset_type}/`).push().key
        updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/creator`] = this.$store.state.user.email
        updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/date_uploaded`] = datetime
      }
      updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/date_modified`] = datetime
    },
    shouldUpload (fileType, updatedData) {
      if (fileType === this.fileType.image) {
        return updatedData.image && updatedData.image.imageFile
      } else if (fileType === this.fileType.fbx) {
        return updatedData.fbx && updatedData.fbx.file
      } else if (fileType === this.fileType.asset_bundle) {
        return (updatedData.asset_bundle.iOS && updatedData.asset_bundle.iOS.file) ||
          (updatedData.asset_bundle.Android && updatedData.asset_bundle.Android.file) ||
          (updatedData.asset_bundle.WebGL && updatedData.asset_bundle.WebGL.file)
      } else {
        return false
      }
    },
    uploadImage (updatedData, updates) {
      assetMediaStorageRef.child(`${updatedData.id}.jpg`)
        .put(updatedData.image.imageFile)
        .then(snapshot => snapshot.ref.getDownloadURL())
        .catch(function (error) {
          console.log(`Error - ${error.message}`)
        })
        .then((url) => {
          updatedData.image.imageURL = url
        })
        .catch(function (error) {
          console.log(`Error - ${error.message}`)
        })
        .then(snapshot => {
          updates[`asset_data/${this.asset_type}/${updatedData.id}/image`] = updatedData.image || {imageURL: '', imageFile: ''}
          console.log('Your image file is saved in storage')
          db.ref('assets').update(updates)
            .then(snapshot => {
              this.closeDialog()
              this.updated = true
              console.log('Your image fileURL is saved in assets')
            })
        })
        .catch(function (error) {
          console.log('Error - ' + error.message)
        })
    },
    uploadFBX (updatedData, updates) {
      assetMediaStorageRef.child(`${updatedData.id}/original.fbx`)
        .put(updatedData.fbx.file)
        .then(snapshot => snapshot.ref.getDownloadURL())
        .catch(function (error) {
          console.log(`Error - ${error.message}`)
        })
        .then((url) => {
          updatedData.fbx.fileURL = url
          console.log('Transferring file url')
        })
        .then(snapshot => {
          updates[`asset_data/${this.asset_type}/${updatedData.id}/fbx`] = updatedData.fbx || {
            fileURL: '',
            file: ''
          }
          console.log('Your fbx file is saved in storage')
          db.ref('assets').update(updates)
            .then(snapshot => {
              this.closeDialog()
              this.updated = true
              console.log('Your fbx fileURL is saved in assets')
            })
        })
    },
    uploadAssetBundle (updatedData, updates, osType) {
      if (updatedData.asset_bundle[osType] && updatedData.asset_bundle[osType].file) {
        assetMediaStorageRef.child(`${updatedData.id}/${osType}`)
          .put(updatedData.asset_bundle[osType].file)
          .then(snapshot => snapshot.ref.getDownloadURL())
          .catch(function (error) {
            console.log(`Error - ${error.message}`)
          })
          .then((url) => {
            updatedData.asset_bundle[osType].fileURL = url
            console.log('Transferring asset bundle url')
          })
          .then(snapshot => {
            let key = `asset_data/${this.asset_type}/${updatedData.id}/asset_bundle/${osType}`
            updates[key] = updatedData.asset_bundle[osType] || {
              fileURL: '',
              file: ''
            }
            console.log(`Your ${osType} asset bundle is saved in storage`)
            db.ref('assets').update(updates)
              .then(snapshot => {
                this.closeDialog()
                this.updated = true
                console.log(`Your ${osType} asset bundle fileURL is saved in assets`)
              })
          })
      }
    },
    openDialog () {
      this.dialog = true
    },
    closeDialog () {
      this.editedID = -1
      this.editedIndex = -1
      this.editedItem = _.cloneDeep(this.defaultItem)
      this.dialog = false
    },
    editItem (item) {
      this.editedIndex = item.index
      this.editedID = item.id
      this.editedItem = item.item
      if (!this.editedItem.hasOwnProperty('positionOfOrigin')) {
        this.editedItem.positionOfOrigin = {
          X: 0,
          Y: 0,
          Z: 0
        }
      }
      if (!this.editedItem.hasOwnProperty('rotationOfOrigin')) {
        this.editedItem.rotationOfOrigin = {
          X: 0,
          Y: 0,
          Z: 0
        }
      }
      if (!this.editedItem.hasOwnProperty('scaleOfOrigin')) {
        this.editedItem.scaleOfOrigin = {
          X: 0,
          Y: 0,
          Z: 0
        }
      }
      this.showSaveButton = item.showSaveButton
      this.dialog = true
    }
  }
}
</script>

<style scoped>
#visualEffect {
scroll-margin: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/assets/effect.vue